import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Services = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const IMAGE_HEIGHT = 220;
  const IMAGE_WIDTH = "100%";

  return (
    <Box sx={{ px: { xs: 2, md: 5 }, py: { xs: 5, md: 8 }, backgroundColor: "#f4f7fb" }}>
      <Grid container spacing={4} justifyContent="center">
        
        {/* === Първа карта: Препарати === */}
        <Grid item xs={12} md={4}>
          <Card
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              justifyContent: "space-between",
              bgcolor: "white",
              boxShadow: 3,
              "&:hover": { transform: "translateY(-4px)", boxShadow: 6 },
              transition: "0.3s",
            }}
          >
            <CardHeader
              title="Продажба на сертифицирани препарати ChemiTek"
              subheader="За соларни панели, фасади и индустриални стъкла"
              titleTypographyProps={{ fontSize: 18, color: "#668cc6", fontWeight: 600 }}
              subheaderTypographyProps={{ fontSize: 16, textAlign: "right", color: "#dcdcdc" }}
            />
            <CardMedia
              component="img"
              image="../images/service-1.png"
              height={IMAGE_HEIGHT}
              sx={{ objectFit: "cover", width: IMAGE_WIDTH, mx: "auto" }}
              alt="Препарати ChemiTek"
            />
            <CardContent sx={{ textAlign: "justify", minHeight: 180 }}>
              <Typography paragraph>
                <b>ChemiTek</b> предлагат сертифицирани препарати за почистване на соларни панели, фасади и индустриални стъкла. 
              </Typography>
              <Typography paragraph>
                Препаратите са безопасни, екологични и ефективни, премахват прах, насекоми, петна и други замърсявания, като осигуряват дълготрайна защита.
              </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: "center", mb: 2 }}>
              <Link to="/preparati-za-solarni-paneli" style={{ textDecoration: "none" }}>
                <Button
                  variant="outlined"
                  sx={{
                    bgcolor: "#fbec77",
                    color: "#3b3b3c",
                    ":hover": { bgcolor: "#648dca", color: "#fff" },
                  }}
                >
                  Вижте още
                </Button>
              </Link>
            </CardActions>
          </Card>
        </Grid>

        {/* === Втора карта: Поддръжка на зелени площи === */}
        <Grid item xs={12} md={4}>
          <Card
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              justifyContent: "space-between",
              bgcolor: "white",
              boxShadow: 3,
              "&:hover": { transform: "translateY(-4px)", boxShadow: 6 },
              transition: "0.3s",
            }}
          >
            <CardHeader
              title="Поддръжка на зелени площи около соларни панели"
              subheader="Косене, поддръжка и безопасност"
              titleTypographyProps={{ fontSize: 18, color: "#668cc6", fontWeight: 600 }}
              subheaderTypographyProps={{ fontSize: 16, textAlign: "right", color: "#dcdcdc" }}
            />
            <CardMedia
              component="img"
              image="../images/service-2.jpg"
              height={IMAGE_HEIGHT}
              sx={{ objectFit: "cover", width: IMAGE_WIDTH, mx: "auto" }}
            />
            <CardContent sx={{ textAlign: "justify", minHeight: 180 }}>
              <Typography paragraph>
                Косенето и поддръжката на площите около соларните панели е ключово за безопасността и ефективността.
              </Typography>
              <Typography fontSize="14px" paragraph>
                - Поддържа висока производителност, като не блокира слънчевата светлина. <br/>
                - Намалява риска от пожари и вредители. <br/>
                - Осигурява лесен достъп за инспекции и ремонти.
              </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: "center", mb: 2 }}>
              <Link to="/contacts" style={{ textDecoration: "none" }}>
                <Button
                  variant="outlined"
                  sx={{
                    bgcolor: "#fbec77",
                    color: "#3b3b3c",
                    ":hover": { bgcolor: "#648dca", color: "#fff" },
                  }}
                >
                  За поръчка
                </Button>
              </Link>
            </CardActions>
          </Card>
        </Grid>

        {/* === Трета карта: Термовизионно заснемане === */}
        <Grid item xs={12} md={4}>
          <Card
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              justifyContent: "space-between",
              bgcolor: "white",
              boxShadow: 3,
              "&:hover": { transform: "translateY(-4px)", boxShadow: 6 },
              transition: "0.3s",
            }}
          >
            <CardHeader
              title="Термовизионно заснемане с дрон"
              subheader="Професионален преглед на соларни панели"
              titleTypographyProps={{ fontSize: 18, color: "#668cc6", fontWeight: 600 }}
              subheaderTypographyProps={{ fontSize: 16, textAlign: "right", color: "#dcdcdc" }}
            />
            <CardMedia
              component="img"
              image="../images/service-4.avif"
              height={IMAGE_HEIGHT}
              sx={{ objectFit: "cover", width: IMAGE_WIDTH, mx: "auto" }}
            />
            <CardContent sx={{ textAlign: "justify", minHeight: 180 }}>
              <Typography paragraph>
                Дронова термовизия за бързо и точно обследване на соларни панели.
              </Typography>
              <Typography fontSize="14px" paragraph>
                - Проверка на производителността и състоянието на клетките. <br/>
                - Висока резолюция с минимални полети. <br/>
                - Подобряване на поддръжката и сигурността на соларната инсталация.
              </Typography>
            </CardContent>
                      <CardActions sx={{ justifyContent: "center", mb: 2 }}>
              <Link to="/contacts" style={{ textDecoration: "none" }}>
                <Button
                  variant="outlined"
                  sx={{
                    bgcolor: "#fbec77",
                    color: "#3b3b3c",
                    ":hover": { bgcolor: "#648dca", color: "#fff" },
                  }}
                >
                  За поръчка
                </Button>
              </Link>
            </CardActions>
          </Card>
        </Grid>

      </Grid>
    </Box>
  );
};

export default Services;
